import { render, staticRenderFns } from "./Contentslist.vue?vue&type=template&id=51740ef1&scoped=true"
import script from "./Contentslist.vue?vue&type=script&lang=js"
export * from "./Contentslist.vue?vue&type=script&lang=js"
import style0 from "./Contentslist.vue?vue&type=style&index=0&id=51740ef1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51740ef1",
  null
  
)

export default component.exports